<template>
    <div>
        <rkm-form ref="Form">
            <rkm-row>
                <rkm-col>
                    <rkm-form-select
                        :options="form.unidades"
                        :validations="validations.unidade"
                        label="Unidade"
                        textField="nomeFantasia"
                        v-model="lotacao.unidadeId"
                        valueField="id"
                        show-default-option
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col>
                    <rkm-form-select
                        :options="infraestruturas"
                        :validations="validations.infraestrutura"
                        label="Local de atendimento"
                        textField="nome"
                        v-model="lotacao.infraestruturaId"
                        valueField="id"
                        show-default-option
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row class="flex-nowrap">
                <rkm-col class="flex-grow-1">
                    <rkm-form-input-autocomplete
                        :searchFields="localForm.autocompleteFields.ocupacao"
                        :repository="repositories.ocupacao"
                        v-model="lotacao.ocupacao"
                        textField="nome"
                        :validations="validations.ocupacao"
                        label="CBO"
                        uppercase
                    />
                </rkm-col>

                <rkm-col class="flex-grow-0 text-nowrap">
                    <rkm-button
                        :label="false"
                        color="primary"
                        @click.stop="$refs.Form.validate(add)"
                    >
                        Incluir
                    </rkm-button>

                    <rkm-button
                        :label="false"
                        color="danger"
                        @click.stop="resetForm"
                    >
                        Limpar
                    </rkm-button>
                </rkm-col>
            </rkm-row>
        </rkm-form>

        <rkm-table
            :fields="fields"
            :items="model.lotacoes"
            ref="Table"
        >
            <template v-slot:cell(realizaAtendimento)="{ item }">
                <rkm-form-checkbox
                    v-model="item.realizaAtendimento"
                    inline
                />
            </template>

            <template v-slot:cell(actions)="{ item }">
                <rkm-button
                    v-if="item.ativo"
                    @click="desativarLotacao(item)"
                    authorize="update-cadastro-usuario"
                    color="dark"
                    small
                    title="Desativar lotação"
                >
                    <rkm-icon icon="ban" />
                </rkm-button>

                <rkm-button
                    v-else
                    @click="ativarLotacao(item)"
                    authorize="update-cadastro-usuario"
                    color="success"
                    small
                    title="Ativar lotação"
                >
                    <rkm-icon icon="check-circle" />
                </rkm-button>

                <rkm-button
                    color="danger"
                    :disabled="item.disabled"
                    title="Excluir"
                    small
                    @click.stop="handleDestroy(item)"
                >
                    <rkm-icon icon="trash" />
                </rkm-button>
            </template>
        </rkm-table>
    </div>
</template>

<script>
import { repository, object } from '@/mixins'

export default {
    mixins: [ repository, object ],
    props: {
        form: { type: Object, required: true },
        model: { type: Object, required: true },
    },
    data: () => ({
        repositories: {
            ocupacao: null
        },
        localForm: {
            autocompleteFields: {
                ocupacao: [
                    { key: 'codigo', searchable: true },
                    { key: 'nome', searchable: true },
                ],
            },
        },
        lotacao: {
            id: null,
            unidadeId: null,
            unidadeNome: '',
            infraestruturaId: null,
            infraestruturaNome: '',
            ocupacao: null,
            realizaAtendimento: false,
        },
        fields: [
            {
                key: 'unidadeNome',
                label: 'Unidade',
                sortable: true,
            },
            {
                key: 'infraestruturaNome',
                label: 'Local de atendimento',
                sortable: true,
            },
            {
                key: 'ocupacao.nome',
                label: 'CBO',
                sortable: true,
            },
            {
                key: 'realizaAtendimento',
                label: 'Realiza atendimento',
                class: 'col-min text-center',
            },
            {
                key: 'actions',
                label: 'Ações',
                class: 'col-min',
            }
        ]
    }),
    computed: {
        validations() {

            return {
                unidade: { required: true },
                infraestrutura: { required: true },
                ocupacao: { required: true },
            }
        },
        infraestruturas() {

            if (this.lotacao.unidadeId) {

                return this.form.unidades.find(u => u.id === this.lotacao.unidadeId).infraestruturas
            }

            return []
        },
    },
    watch: {
        'lotacao.unidadeId': function () {

            this.lotacao.infraestruturaId = null
        },
    },
    methods: {
        async validate() {

            return true
        },
        add() {

            this.validateDuplicity()
                .then(valid => {

                    if (!valid) return

                    const lotacao = this.clone(this.lotacao)

                    if (lotacao.id == null) {

                        lotacao.id = this.uniqueId('lotacao' + new Date().getTime())
                    }

                    lotacao.unidadeNome = this.form.unidades
                        .find(u => u.id === this.lotacao.unidadeId)
                        .nomeFantasia

                    lotacao.infraestruturaNome = this.infraestruturas
                        .find(i => i.id === this.lotacao.infraestruturaId)
                        .nome

                    this.model.lotacoes.push(lotacao)

                    if (lotacao.realizaAtendimento && !this.model.documentos.conselhoProfissional.registroNumero) {

                        this.showAlert('Devido à CBO selecionada realizar atendimentos, preencha na aba'
                            + ' Documentos o CONSELHO PROFISSIONAL.')
                    }

                    this.resetForm()
                })
        },
        async validateDuplicity() {

            const hasLotacao = this.model.lotacoes
                .find(lotacao => lotacao.infraestruturaId === this.lotacao.infraestruturaId
                    && lotacao.ocupacao.id === this.lotacao.ocupacao.id)

            if (hasLotacao) {

                this.showValidationNotification('A lotação já existe.')

                return false
            }

            return true
        },
        resetForm() {

            this.lotacao.id = null
            this.lotacao.unidadeId = null
            this.lotacao.unidadeNome = ''

            this.lotacao.infraestruturaId = null
            this.lotacao.infraestruturaNome = ''

            this.lotacao.ocupacao = null
            this.lotacao.realizaAtendimento = false

            this.$nextTick(() => this.$refs.Form.resetValidator())
        },
        handleDestroy(item) {

            const objIndex = this.model.lotacoes.findIndex((obj => obj.id == item.id));

            const destroy = async () => this.model.lotacoes.splice(objIndex, 1)

            this.showDeleteConfirmation('Deseja realmente excluir a unidade?', destroy)
        },
        desativarLotacao(item) {
            this.createNotification({
                type: 'dialog',
                color: 'danger',
                title: 'Confirmação',
                message: `Deseja desativar a lotação?`,
                confirm: async () => item.ativo = false,
            })
        },
        ativarLotacao(item) {
            this.createNotification({
                type: 'dialog',
                color: 'success',
                title: 'Confirmação',
                message: `Deseja ativar a lotação?`,
                confirm: async () => item.ativo = true,
            })
        },
    },
    created() {

        this.repositories.ocupacao = this.getConectaSusRepository('sigtap.ocupacao')
    },
}
</script>